import React from 'react';

const dialogHeader = () => {
	return (
		<div className='dialogHeader'>
			<div className='first'>
				<p className='fs-13 lc'>No contenaire</p>
				<p className='fs-20'>C2122-000734</p>
			</div>
			<div className='second'>
				<p className='fs-13 lc'>C2122-000734</p>
				<p className='fs-20'>P2122-87996</p>
			</div>
			<div className='third'>
				<p className='fs-13 lc'>40P FRIG</p>
				<p className='fs-20'>Mandarine</p>
			</div>
			<div className='forth'>
				<p className='fs-13 lc'>Statut</p>
				<p className='fs-20'>Lorem Ipsum is simply d...</p>
			</div>
		</div>
	);
};

export default dialogHeader;
